import { useMemo, useState } from "react";
import { CATEGORIES } from "@/mocks/categories";
import { ARTICLES, getByViews } from "@/mocks/articles";
import { FeedCard, RankItem } from "@/components/ui/ArticleView";
import { SubscribeForm } from "@/components/ui/forms";
import SectionHeading from "@/components/ui/Section";

const TABS = [{ key: "all", label: "全部爆料" }, ...CATEGORIES.map((c) => ({ key: c.key, label: c.name }))];

export default function LatestFeed() {
  const [tab, setTab] = useState("all");

  const list = useMemo(() => {
    const base = [...ARTICLES].sort((a, b) => (a.date < b.date ? 1 : -1));
    return tab === "all" ? base : base.filter((a) => a.category === tab);
  }, [tab]);

  const picks = getByViews(5);

  return (
    <section className="container-page mt-14 md:mt-20">
      <SectionHeading
        kicker="The Latest Scoop"
        title="最新圈内爆料"
        desc="从剧组盒饭到大夜戏时间表，从试镜室到应酬桌——只收录愿意核实、且以匿名信源叙述的内容，每日滚动更新。"
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        {/* 信息流 */}
        <div className="lg:col-span-2">
          <div className="mb-5 inline-flex max-w-full overflow-x-auto rounded-full border border-background-200 bg-background-100 p-1">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  tab === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {list.map((a) => (
              <FeedCard key={a.slug} a={a} />
            ))}
          </div>

          {list.length === 0 && (
            <p className="rounded-lg border border-background-200 bg-background-100 p-8 text-center text-sm text-foreground-500">
              该栏目暂无内容，敬请期待。
            </p>
          )}
        </div>

        {/* 侧栏 */}
        <aside className="space-y-6">
          <div className="rounded-lg border border-accent-300 bg-accent-100 p-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-mail-star-line"></i>
              </span>
              <div>
                <h4 className="font-heading text-base font-extrabold text-foreground-950">
                  每日瓜讯订阅
                </h4>
                <p className="text-xs text-foreground-600">
                  热瓜首发，一封邮件看完当天重点
                </p>
              </div>
            </div>
            <div className="mt-4">
              <SubscribeForm />
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
              <h4 className="flex items-center gap-2 font-heading text-base font-extrabold text-foreground-950">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
                  <i className="ri-fire-line"></i>
                </span>
                编辑必看
              </h4>
              <span className="text-xs text-foreground-400">最多讨论</span>
            </div>
            <div className="px-4 py-1">
              {picks.map((a, i) => (
                <RankItem key={a.slug} a={a} index={i} />
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}